var synMenu = {};

(function(exports) {
  exports.openMobileMenu = function() {
    const mobileMenuButton = document.querySelector('.menu-button.menu-button__mobile');
    const mobileMenu = document.getElementById('mobileMenu');
    
    mobileMenuButton.classList.add('menu-button__close');
    mobileMenu.classList.add('dropdown-menu__expanded');
  };
  
  exports.closeMobileMenu = function() {
    const mobileMenuButton = document.querySelector('.menu-button.menu-button__mobile');
    const mobileMenu = document.getElementById('mobileMenu');

    mobileMenuButton.classList.remove('menu-button__close');
    mobileMenu.classList.remove('dropdown-menu__expanded');
  };
})(synMenu);